import React, { Component } from "react";
import axios from "axios";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import {
  Container,
  Paper,
  Grid,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  TextField,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  RadioGroup,
  FormControlLabel,
  Radio
} from "@mui/material";
import EditIcon from '@mui/icons-material/EditSquare';

import FileDownloadIcon from '@mui/icons-material/FileDownload';
import SearchIcon from '@mui/icons-material/Search';
import Autocomplete from "@mui/material/Autocomplete";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TableFooter } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Serverurl from "./Apiurl";
export default class Payment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fromDate: dayjs().startOf("month"),
      toDate: dayjs(),
      projectId: "",
      selectedProject: null,
      projectarrauto: [],
      reportData: [],
	  pi_id: 0,
pi_pj_id: "",
pi_date: dayjs(),
pi_amount: "",
pi_mode: "",
pi_remarks: "",
pi_bill: "",
openInsert: false,
openEdit: false,
selectedProjectInsert: null,
selectedProjectEdit: null,
pi_pj_id: "",
totalAmount:0,
      page: 0,
      rowsPerPage: 50,
      totalRecords: 0,
      loading: false
    };
  }
   componentWillMount() {
        document.title = "VR Builders - Payments";
        
   	if(localStorage.getItem("VRuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Userlogin'
          })
		  }
let strname="Customer Payments";   
			 this.props.parentsCallback(
           strname
        );
  const userid = localStorage.getItem("VRuserid");
  this.setState({ userid: userid }, () => {
    this.apicall(this.state.page, this.state.rowsPerPage);
  });
}
  //PROJECT SEARCH
 onloadProjectBind = (event) => {
  axios
    .get(
      Serverurl +
        "ajaxprojects.php?action=getallprojectautoextender&projectname=" +
        event.target.value
    )
    .then((res) => {
      const list =
        res.data && res.data.length > 0
          ? res.data.map((r) => ({
              title: r.pj_projectname,
              pj_id: r.pj_id
            }))
          : [];
      this.setState({
        projectarrauto: list
      });
    })
    .catch(() => {
      this.setState({
        projectarrauto: []
      });
    });
};
apicall = (page, rowsPerPage) => {
  this.setState({ loading: true });
axios.get(
  Serverurl +
  "ajaxpaymentin.php?action=getall" +
  "&pi_pj_id=" + this.state.projectId +
  "&fromdate=" + this.state.fromDate.format("YYYY-MM-DD") +
  "&todate=" + this.state.toDate.format("YYYY-MM-DD") +
  "&StartIndex=" + page +
  "&PageSize=" + rowsPerPage +
  "&sorting=pi_id desc"
)
    .then((resp) => {
      if (resp.data.length > 0) {
		    const data = resp.data || [];
		   let totalAmount = 0;
		    data.forEach((item) => {
			  totalAmount += Number(item.pi_amount || 0);
        });
        this.setState({
          reportData: resp.data,
          totalRecords: parseInt(resp.data[0].count || 0),
          loading: false,totalAmount:totalAmount,
        });
      } else {
        this.setState({
          reportData: [],
          totalRecords: 0,
          loading: false
        });
      }
    })
    .catch(() => {
      this.setState({ loading: false });
    });
};
handlePageChange = (event, newPage) => {
  this.setState(
    { page: newPage },
    () => this.apicall(newPage, this.state.rowsPerPage)
  );
};
handleRowsChange = (event) => {
this.setState(
  { rowsPerPage: parseInt(event.target.value, 10), page: 0 },
  () => this.apicall(0, this.state.rowsPerPage)
);
};
downloadBill = (file) => {
 window.open(Serverurl + "uploads/" + file, "_blank");
};
handleSearch = (e) => {
  if (e) e.preventDefault();
  this.apicall(0, this.state.rowsPerPage);
};
onProjectChange = (event, value) => {
  this.setState({
    selectedProject: value,
    projectId: value ? value.pj_id : ""
  });
};
  render() {
    return (
       <React.Fragment>

  

   

       <div className="searchmaster">
            <ul>
                                <li>

        <p>From Date</p>    
 <p><LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
		disableFuture className="inputcntlparent"
		format="DD/MM/YYYY"
          value={this.state.fromDate}
          onChange={(v) => this.setState({ fromDate: v })}
          slotProps={{ textField: { size: "small", fullWidth: true } }}
        /> </LocalizationProvider></p>   </li>


  <li>
        <p>To Date</p>
          <p><LocalizationProvider dateAdapter={AdapterDayjs}><DatePicker
		disableFuture className="inputcntlparent"
		format="DD/MM/YYYY"
          value={this.state.toDate}
          onChange={(v) => this.setState({ toDate: v })}
          slotProps={{ textField: { size: "small", fullWidth: true } }}
        /></LocalizationProvider>  </p>
      </li>

       <li>
        <p>Project</p>
        <p> <Autocomplete className="inputcntlparent"
          options={this.state.projectarrauto}
          value={this.state.selectedProject}
          onChange={this.onProjectChange}
          getOptionLabel={(o) => o.title || ""}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              placeholder="Select Project"
              onChange={this.onloadProjectBind}
            />
          )}
        /> </p>
      </li>

       <li>
             <p><Button
    
          variant="contained" className="exportbtn"
          onClick={this.handleSearch} endIcon={<SearchIcon />}
        >
          Search
        </Button>     </p>
      </li>

     </ul>
 
</div>

          {/* TABLE */}
          <TableContainer sx={{ mt: 3 }}>
            <Table>
              <TableHead>
                <TableRow >
                  <TableCell >Project</TableCell>
                  <TableCell >Date</TableCell>
				    <TableCell >Amount</TableCell>
                  <TableCell >Mode</TableCell>
				  <TableCell >Remarks</TableCell>
				 		  <TableCell >Bill</TableCell>
				   <TableCell ></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.reportData.map((r, i) => (
                  <TableRow key={i}>
                    <TableCell>{r.pj_projectname}</TableCell>
                    <TableCell>
                      {r.pi_date
                        ? dayjs(r.pi_date).format("DD-MM-YYYY")
                        : ""}
                    </TableCell>
					 <TableCell>
                     Rs. {parseFloat(r.pi_amount ).toFixed(2)}
                    </TableCell>
                    <TableCell>{r.pi_modename}</TableCell>
					 <TableCell>{r.pi_remarks}</TableCell>
					 <TableCell>
{r.pi_bill!=="" && (
<a href={Serverurl+"uploads/"+r.pi_bill} target="_blank"><FileDownloadIcon /></a>

)}


</TableCell>
<TableCell>
{r.pj_isactive ==="0" && (

  <Link to={`/Paymenttransactions?pi_id=${r.pi_id}`}>
  <Button variant="contained" className="editbtn"  endIcon={<EditIcon />}>

</Button>
  </Link>
)}
    </TableCell>
                  </TableRow>
                ))}
				 <TableRow>
				  <TableCell colSpan={2}><b>Total </b></TableCell>
				    <TableCell ><b>Rs.{this.state.totalAmount.toLocaleString("en-IN")}</b></TableCell>
				   </TableRow>
				
              </TableBody>
			  <TableFooter>
  <TableRow>
    <TableCell colSpan={3}></TableCell>
  </TableRow>
</TableFooter>
            </Table>
					  <TablePagination
					   rowsPerPageOptions={[50, 100, 150, 200, 250]}  
  component="div"
  count={this.state.totalRecords}
  page={this.state.page}
  onPageChange={this.handlePageChange}
  rowsPerPage={this.state.rowsPerPage}
  onRowsPerPageChange={this.handleRowsChange}
/>
          </TableContainer>
       </React.Fragment>
    );
  }
}
